<div class="parent-container">
  <button #pickerButton mat-button (click)="toggleEmojiPicker()" [ngStyle]="{ 'background-color': backgroundColor }" class="emoji-button">
    <span [innerHTML]="selectedEmoji"></span>
  </button>

  <div *ngIf="showEmojiPicker" class="emoji-picker-container" [ngStyle]="emojiPickerStyle">
    <emoji-mart [custom]="customEmojis" title="Pick your emoji…" (emojiClick)="onEmojiSelect($event)"></emoji-mart>
  </div>
</div>
